import { render, staticRenderFns } from "./add-opinion.vue?vue&type=template&id=146245d4&scoped=true"
import script from "./add-opinion.vue?vue&type=script&lang=js"
export * from "./add-opinion.vue?vue&type=script&lang=js"
import style0 from "./add-opinion.vue?vue&type=style&index=0&id=146245d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146245d4",
  null
  
)

export default component.exports